import React from "react";
import styled from "@emotion/styled";
import handphone from "images/pdp-catalogue/handphone.png";
import { Link } from "gatsby";

const Catalogue = styled.div`
  background-color: black;
`;

const Back = styled.div`
  padding-left: 1em;
`;

const CatalogueFont = styled.div`
  font-size: 18px;
  padding-left: 1em;
  font-weight: bold;
`;

const WrapContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 0.85em;
`;

const Wrap = styled.div`
  display: flex;
  flex-direction: row;
`;

const Prize = styled.div`
  display: 100%;
  padding-top: 1em;

  img {
    width: 265px;
    height: 265px;
  }
`;

const Center = styled.div`
  margin: 0 auto;
  text-align: center;
  align-items: center;
`;

const PrizeName = styled.div`
  font-size: 30px;
  align-items: center;
  font-weight: bold;
  padding-top: 0.75em;
  text-align: center;
`;

const Points = styled.div`
  padding-left: 0.25em;
  font-size: 30px;
  font-weight: bold;
  align-items: center;
  text-align: center;
`;

const PointsLogo = styled.div`
  padding-top: 0.35em;
`;

export default function PDPCatalogue(props) {
  return (
    <Catalogue>
      <Wrap>
        <Link to="/play/catalogue">
          <Back>
            <svg
              width="15"
              height="26"
              viewBox="0 0 15 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.9932 1.47998L2.48001 12.9886L12.9895 24.4581"
                stroke="white"
                stroke-width="2"
              />
            </svg>
          </Back>
        </Link>
        <CatalogueFont>Catalogue</CatalogueFont>
      </Wrap>
      <Center>
        <Prize>
          <img src={props.prizeImg} />
        </Prize>
        <PrizeName>{props.prizeName}</PrizeName>
        <WrapContent>
          <PointsLogo>
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="11.7184" cy="12.4293" r="11.7184" fill="white" />
              <path
                d="M11.953 17.5032H9.1125V6.98585H11.8644C13.2359 6.98585 14.2531 7.26513 14.9161 7.8237C15.6972 8.48216 16.0877 9.39721 16.0877 10.5688C16.0877 11.8449 15.6722 12.7963 14.8412 13.4229C14.2735 13.8453 13.4584 14.0564 12.3958 14.0564H11.953V17.5032ZM11.953 11.6928L12.0824 11.6996C12.4275 11.6996 12.7023 11.5951 12.9066 11.3862C13.111 11.1728 13.2132 10.8822 13.2132 10.5143C13.2132 10.151 13.1133 9.85586 12.9134 9.62881C12.7136 9.39721 12.4593 9.28141 12.1505 9.28141H11.953V11.6928Z"
                fill="black"
              />
            </svg>
          </PointsLogo>
          <Points>{props.points}</Points>
        </WrapContent>
      </Center>
    </Catalogue>
  );
}

PDPCatalogue.defaultProps = {
  prizeImg: handphone,
  prizeName: "Samsung A5",
  points: "500"
};
